(function (global) {
  'use strict';

  function visibleColors(buttons, selected, maximum) {
    var items = Array.from(buttons || []);
    var limit = Math.max(1, Number(maximum) || 3);
    var preview = items.slice(0, limit);
    if (preview.length && items.indexOf(selected) >= 0 && preview.indexOf(selected) === -1) {
      preview[preview.length - 1] = selected;
    }
    return preview;
  }

  function formatCurrency(cents, locale, currency) {
    var number = Number(cents);
    if (!Number.isFinite(number)) return '';
    try {
      return new Intl.NumberFormat(locale || 'tr-TR', {
        style: 'currency', currency: currency || 'TRY'
      }).format(number / 100);
    } catch (_) {
      return new Intl.NumberFormat('tr-TR', {
        style: 'currency', currency: 'TRY'
      }).format(number / 100);
    }
  }

  function bindCard(card, locale, currency) {
    if (card.dataset.hspBound === 'true') return;
    card.dataset.hspBound = 'true';
    var priceEl = card.querySelector('[data-hsp-price]');
    if (priceEl && priceEl.dataset.hspPriceCents) {
      priceEl.textContent = formatCurrency(priceEl.dataset.hspPriceCents, locale, currency);
    }
    var container = card.querySelector('[data-hsp-colors]');
    if (!container) return;
    var buttons = Array.from(container.querySelectorAll('[data-hsp-color]'));
    if (!buttons.length) return;
    var palette = global.HanezzaColorPalette;
    buttons.forEach(function (button) {
      var dot = button.querySelector('.hsp__color-dot');
      if (palette && typeof palette.paint === 'function') {
        palette.paint(dot, button.dataset.hspColorName, {
          nativeColor: button.dataset.hspNativeColor,
          nativeImage: button.dataset.hspNativeImage,
          variantImage: button.dataset.hspSwatchVariantImage
        });
      }
    });
    var more = container.querySelector('[data-hsp-more-colors]');
    var isTurkish = /^tr\b/i.test(locale || '');
    var expanded = false;

    function updateCompact() {
      var chosen = buttons.find(function (btn) {
        return btn.getAttribute('aria-pressed') === 'true';
      });
      var first = visibleColors(buttons, chosen, 3);
      buttons.forEach(function (btn) {
        btn.dataset.hspOverflow = String(first.indexOf(btn) < 0);
      });
      container.dataset.hspExpanded = String(expanded);
      if (more) {
        var extraCount = Math.max(0, buttons.length - 3);
        more.hidden = extraCount === 0;
        more.textContent = expanded ? '−' : '+' + extraCount;
        more.setAttribute('aria-expanded', String(expanded));
        more.setAttribute('aria-label', expanded
          ? (isTurkish ? 'Daha az renk göster' : 'Show fewer colors')
          : (isTurkish ? extraCount + ' renk daha göster' : 'Show ' + extraCount + ' more colors'));
      }
    }

    container.addEventListener('click', function (event) {
      var moreButton = event.target.closest('[data-hsp-more-colors]');
      if (moreButton) {
        expanded = !expanded;
        updateCompact();
        return;
      }
      var swatch = event.target.closest('[data-hsp-color]');
      if (!swatch || swatch.disabled) return;
      buttons.forEach(function (btn) {
        btn.setAttribute('aria-pressed', String(btn === swatch));
      });
      var url = swatch.dataset.hspVariantUrl;
      var photoUrl = swatch.dataset.hspVariantImage || '';
      var price = swatch.dataset.hspVariantPriceCents;
      card.querySelectorAll('[data-hsp-picture-link],[data-hsp-title-link],[data-hsp-explore]').forEach(function (link) {
        if (url) link.setAttribute('href', url);
      });
      var priceNode = card.querySelector('[data-hsp-price]');
      if (priceNode && price) priceNode.textContent = formatCurrency(price, locale, currency);
      var img = card.querySelector('.hsp__image');
      var missing = card.querySelector('[data-hsp-missing-color]');
      var fallbackImage = card.querySelector('.hsp__empty-image');
      if (img) {
        img.hidden = !photoUrl;
        if (photoUrl) {
          img.setAttribute('src', photoUrl);
          img.removeAttribute('srcset');
          img.removeAttribute('sizes');
        }
      }
      if (missing) missing.hidden = !!photoUrl;
      if (fallbackImage) fallbackImage.hidden = !photoUrl;
      updateCompact();
    });
    updateCompact();
  }

  function mount(root) {
    if (root.dataset.hspMounted === 'true') return;
    root.dataset.hspMounted = 'true';
    var track = root.querySelector('[data-hsp-track]');
    var prev = root.querySelector('[data-hsp-prev]');
    var next = root.querySelector('[data-hsp-next]');
    if (!track) return;
    var locale = root.dataset.hspLocale || 'tr';
    var currency = root.dataset.hspCurrency || 'TRY';

    function bindCards() {
      track.querySelectorAll('[data-hsp-card]').forEach(function (card) {
        bindCard(card, locale, currency);
      });
    }

    function syncNavigation() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      var position = Math.abs(track.scrollLeft);
      if (prev) prev.disabled = position <= 2;
      if (next) next.disabled = position >= maxScroll - 2;
      root.hidden = track.querySelectorAll('[data-hsp-card]').length === 0 && root.dataset.hspSource === 'recommendations';
    }

    function travel(direction) {
      var card = track.querySelector('[data-hsp-card]');
      var cardWidth = card ? card.getBoundingClientRect().width : track.clientWidth;
      var styles = global.getComputedStyle ? global.getComputedStyle(track) : null;
      var gap = styles ? parseFloat(styles.columnGap || styles.gap) || 0 : 0;
      var rtl = styles && styles.direction === 'rtl';
      track.scrollBy({ left: direction * (rtl ? -1 : 1) * (cardWidth + gap), behavior: 'smooth' });
    }
    if (prev) prev.addEventListener('click', function () { travel(-1); });
    if (next) next.addEventListener('click', function () { travel(1); });
    track.addEventListener('scroll', syncNavigation, { passive: true });
    track.addEventListener('keydown', function (event) {
      if (event.target !== track) return;
      if (event.key === 'ArrowRight') { event.preventDefault(); travel(1); }
      if (event.key === 'ArrowLeft') { event.preventDefault(); travel(-1); }
    });
    global.addEventListener('resize', syncNavigation, { passive: true });
    bindCards();
    syncNavigation();

    if (root.dataset.hspSource === 'manual' || root.dataset.hspRecommendations === 'true') return;
    var endpoint = root.dataset.hspRecommendationsUrl;
    if (!endpoint || !global.fetch) return;
    var loading = false;
    function enhanceWithShopify() {
      if (loading) return;
      loading = true;
      global.fetch(endpoint, { credentials: 'same-origin' }).then(function (response) {
        if (!response.ok) throw new Error('Recommendations unavailable');
        return response.text();
      }).then(function (html) {
        var doc = new global.DOMParser().parseFromString(html, 'text/html');
        var replacement = doc.querySelector('[data-hsp-root]');
        var list = replacement && replacement.querySelector('[data-hsp-track]');
        if (!replacement || replacement.dataset.hspSource !== 'recommendations' || !list ||
            !list.querySelector('[data-hsp-card]')) return;
        track.replaceChildren.apply(track, Array.from(list.children));
        root.dataset.hspSource = 'recommendations';
        bindCards();
        syncNavigation();
      }).catch(function () {
        // Keep same-collection fallback; hide only a truly empty recommendation area.
        if (!track.querySelector('[data-hsp-card]')) root.hidden = true;
      });
    }
    if ('IntersectionObserver' in global) {
      var observer = new global.IntersectionObserver(function (entries) {
        if (entries[0] && entries[0].isIntersecting) {
          observer.disconnect();
          enhanceWithShopify();
        }
      }, { rootMargin: '250px 0px' });
      observer.observe(root);
    } else {
      enhanceWithShopify();
    }
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { visibleColors: visibleColors };
  }
  if (typeof document !== 'undefined') {
    function init() {
      document.querySelectorAll('[data-hsp-root]').forEach(mount);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
    document.addEventListener('shopify:section:load', init);
  }
})(typeof window !== 'undefined' ? window : globalThis);
